// extracted by mini-css-extract-plugin
export default {"error":"inline-error-message_error__NP5tp"};